import { render, staticRenderFns } from "./CoachManagerStatusList.vue?vue&type=template&id=f6b96e0a"
import script from "./CoachManagerStatusList.vue?vue&type=script&lang=js"
export * from "./CoachManagerStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports